import {
    Component, Mixins,
} from 'vue-property-decorator';
import { get } from 'lodash/object';
import { digits } from '@nodes/helpers/number';

@Component
/**
 * ListWrapper Props
 */
export default class Props extends Mixins() {
    /**
     * Handle response error
     *
     * @param {object} responseError
     * @param {string} message
     */
    handleError(responseError: object, message?: string) {
        const status = get(responseError, 'response.status');
        const response = get(responseError, 'response.data', {});
            
        if (status >= 500) {
            const msg = get(response, 'userMessage', this.$t('errors.500.title'));
            this.$toast.error(digits(msg, this.$i18n.locale));
        } else if (response.errorCode === 422) {
            let messages = response.errors;
            let items: Array<any> = [];
            messages = Object.keys(messages).map((key) => {
                items = [...items, ...messages[key]];
                return true;
            }, []);
            let output: any = '<ul>';
            items.map((item) => {
                output += `<li>${item}</li>`;
                return true;
            });
            output += '</ul>';
            // TODO it's just for demo
            output = output.replaceAll('</ul>', '').replaceAll('<ul>', '').replaceAll('<li>', '').replaceAll('</li>', '\n');
            this.$toast.error(digits(output, this.$i18n.locale));
        } else if (response.errorCode === 401 || response.errorCode === 'endpoint-403') {
            const params = {
                name  : this.$route.name,
                params: { ...this.$route.params },
                query : { ...this.$route.query },
            };
            this.$store.dispatch('auth/setRedirect', params).then(() => {
                this.$store.dispatch('auth/logout');
                // TODO: Read This route name from project config
                this.$router.push({ name: 'auth-login' }).catch((error) => {
                    this.handleError(error);
                });
            });
        } else {
            const msg = get(response, 'userMessage', '') || message;
            if (msg) {
                this.$toast.error(digits(msg, this.$i18n.locale));
            }
        }
    }
}
